import { environment } from "src/environments/environment";

export const LANDING_DATA = {
  medical: {
    cause: 'medical',
    seo_data: {
      metaTitle: 'People Supporting People: Your support, their survival | Ketto Medical Crowdfunding',
      metaDescription: 'By contributing generously to campaigns on Ketto you can save lives. Contribute today to Crowdfunding for medical expenses and medical treatment.',
      metaKeywords: 'Medical Crowdfunding, Raise Funds for Medical Treatment, Medical fundraising, best way to raise money for medical expenses, fundraiser for medical expenses, Financial Help for Medical Treatment in India, Fundraising for Medical Expenses',
      metaImage: `${environment.APP.DOMAIN_URL}/assets/images/medical-01.png`
    },
    banner: {
      cause: 'medical',
      image: '/assets/images/banner-5.png',
      title: 'Let’s stop critical illness patients from dying',
      text: 'Become part of a community of change makers, who save a life, every month'
    },
    monthly_program: {
      cause: 'medical',
      title: 'Save a life, every month',
      text: 'Automated monthly contributions',
      points: [
        { icon: 'schedule', text: 'Priority contributions towards most critical cases' },
        { icon: 'notifications_none', text: 'Regular updates on their current condition' },
        { icon: 'star_border', text: 'Exclusive monthly wellness benefits for you' },
        { icon: 'percent', text: 'Tax deduction under Section 80G' }
      ]
    },
    achievements: {
      cause: 'medical',
      desktop_image: '/assets/images/education-fundraising/medical-desktop-01.png',
      mobile_image: '/assets/images/education-fundraising/medical-mobile-01.png',
      raised: '100cr+',
      donors: '',
      saved: '32,541',
      saved_text: 'Lives Saved'
    },
    success_stories: {
      cause: 'medical',
      title: 'Success Stories',
      stories: [
        {
          title: 'Deepak Singh',
          description: '“We were able to save our premature baby, Tanishk from a breathing disorder.”',
          raised: 1327590,
          supporters: '1,364',
          img: '/assets/images/sip/testimonial-1.png'
        },
        {
          title: 'Natasha',
          description: '“Thanks to all your contributions Fahim underwent a successful Liver Transplant.”',
          raised: 1556140,
          supporters: '485',
          img: '/assets/images/sip/testimonial-2.png'
        },
        {
          title: 'Shailaja',
          description: '“Hannan was diagnosed with a heart condition but was cured and is now completely healthy.”',
          raised: 251080,
          supporters: '103',
          img: '/assets/images/sip/testimonial-3.png'
        },
        {
          title: 'Shailaja',
          description: '“Kashap is now 5 years old! She weighs 10 kg and is completely healthy and happy.”',
          raised: 458852,
          supporters: '79',
          img: '/assets/images/sip/testimonial-4.png'
        }
      ]
    },
    testimonials: {
      cause: 'medical',
      title: 'Testimonials',
      testimonials: [
        {
          content: `My experience on Ketto has been great. I know my contributions are going to children who are in desperate need and I feel like I am making a difference.`,
          name: 'Disha',
          image: '/assets/images/sip/testimonials/disha.png',
          donor_type_text: 'Monthly Contributor'
        },
        {
          content: `I give Rs 1000 every month to help needy children get life-saving treatments. When I hear their recovery stories, it fills my heart with utmost joy!`,
          name: 'Nitya',
          image: '/assets/images/sip/testimonials/nitya.png',
          donor_type_text: 'Monthly Contributor'
        },
        {
          content: `I might not be able to save someone alone, but together, there’s so much hope. There’s no better feeling than being a part of someone’s recovery journey.`,
          name: 'Suraj',
          image: '/assets/images/sip/testimonials/suraj.png',
          donor_type_text: 'Monthly Contributor'
        }
      ]
    },
    dockbtn: {
      label: 'Start Monthly Giving'
    }
  },
  animals: {
    cause: 'animals',
    seo_data: {
      metaTitle: 'Become a Change-Maker: Contribute & Save a Life-One Pet at a Time | Ketto',
      metaDescription: 'Homeless animals need our support and love. Your Contributions for homeless animals will save their lives. Contribute generously on Ketto today.',
      metaKeywords: 'Fundraisers for Animals, Medical Treatments of animals, Animal Fundraising, START AN ANIMAL FUNDRAISING',
      metaImage: `${environment.APP.DOMAIN_URL}/assets/images/animals/animal-02.png`
    },
    banner: {
      cause: 'animals',
      image: '/assets/images/animals/animal-06.png',
      title: 'Let’s help homeless animals every month',
      text: 'Become part of a community of change makers, who save animals every month'
    },
    monthly_program: {
      cause: 'animals',
      title: 'Save animals every month',
      text: 'Provide better living conditions for homeless animals across India',
      points: [
        { icon: 'pets', text: 'Help provide food and shelter' },
        { icon: 'control_point', text: 'Fund essential medical treatments' },
        { icon: 'notifications_none', text: 'Regular updates on their current condition' },
        { icon: 'percent', text: 'Tax deduction under Section 80G' }
      ]
    },
    achievements: {
      cause: 'animals',
      desktop_image: '/assets/images/animals/animal-desktop-01.png',
      mobile_image: '/assets/images/animals/animal-mobile-01.png',
      raised: '25cr+',
      donors: '10,268',
      saved: '17,390',
      saved_text: 'Lives Saved'
    },
    success_stories: {
      cause: 'animals',
      title: 'Success Stories',
      stories: [
        {
          title: 'Anuradha Dogra',
          description: 'Home to more than 1500 lives, we are always striving to provide for helpless animals in need and take care of them. The response that we received from Ketto greatly helped us raise funds to help our furry friends.',
          raised: 826357,
          supporters: '495',
          img: '/assets/images/animals/animal-02.png'
        },
        {
          title: 'Sanjeev Pednekar',
          description: 'Currently, we are home to about 700 animals out of which 80% are rescued. It is so heartwarming to see how Ketto is helping by bringing so many people together to help these beautiful souls.',
          raised: 2407384,
          supporters: '1,356',
          img: '/assets/images/animals/animal-03.png'
        },
        {
          title: 'World For All Animal Care & Adoptions',
          description: 'Earlier, it got difficult to maintain quality services for our animals and needed funds to feed & provide medical attention for stray dogs and cats. But, generous contributors & Ketto saved us from this financial crisis.',
          raised: 1430429,
          supporters: '477',
          img: '/assets/images/animals/animal-04.png'
        }
      ]
    },
    testimonials: {
      cause: 'animals',
      title: 'Testimonials',
      testimonials: [
        {
          content: `Despite having always supported animal welfare, it can be challenging to step out and actually help them with a busy lifestyle. With Ketto, I have been able to contribute to animal causes that I know have helped saved countless lives of innocent animals.`,
          name: 'Aditi Gupta',
          image: '',
          donor_type_text: 'Monthly Contributor'
        },
        {
          content: `It touches my heart to see people suffering due to their impoverished conditions. I've been able to contribute to such causes thanks to Ketto and its genuine work, and it gives me the joy to know that I'm supporting such precious lives.`,
          name: 'Ashish Waghmare',
          image: '',
          donor_type_text: 'Monthly Contributor'
        },
        {
          content: `Initially, we had difficulty maintaining quality services for our animals and needed funds to feed and provide medical attention for stray dogs and cats. But thanks to generous contributors and Ketto, we were saved from this financial crisis.`,
          name: 'Deepak Nayak',
          image: '',
          donor_type_text: 'Monthly Contributor'
        }
      ]
    },
    dockbtn: {
      label: 'Start Monthly Giving'
    }
  },
  education: {
    cause: 'education',
    seo_data: {
      metaTitle: 'Gift Children with Education by Contributing Monthly - Ketto',
      metaDescription: 'With Ketto’s Social Impact Plan for Education, you can contribute monthly to provide children with education and other necessary facilities like stationary and school uniforms.',
      metaKeywords: 'Education Crowdfunding, Raise Funds for Children Education, Education fundraising, best way to raise money for education, fundraiser for education expenses, Financial Help for Education in India, Fundraising for Education Expenses',
      metaImage: `${environment.APP.DOMAIN_URL}/assets/images/education-fundraising/img-1.png`
    },
    banner: {
      cause: 'education',
      image: '/assets/images/education-fundraising/child-01.png',
      title: 'Send a child to school, every month',
      text: 'Become part of a community of change makers, who provide education to kids every month'
    },
    monthly_program: {
      cause: 'education',
      title: 'Educate a child, every month',
      text: 'Help children in poverty break free and follow their dreams.',
      points: [
        { icon: 'currency_rupee', text: 'Help the children by covering their tuition fee' },
        { icon: 'settings_accessibility', text: 'Provide for their school uniforms and other essentials' },
        { icon: 'edit', text: 'Cover their much needed stationary expenses' },
        { icon: 'percent', text: 'Tax deduction under Section 80G' }
      ]
    },
    achievements: {
      cause: 'education',
      desktop_image: '/assets/images/education-fundraising/medical-desktop-01.png',
      mobile_image: '/assets/images/education-fundraising/medical-mobile-01.png',
      raised: '60cr+',
      donors: '250k+',
      saved: '4k+',
      saved_text: 'Lives Saved'
    },
    success_stories: {
      cause: 'education',
      title: 'Success Stories',
      stories: [
        {
          title: 'Child Health Foundation',
          description: '“With thousands of children to care for, we’re constantly striving to ensure they grow up equipped to build a better future. The support that we receive from Ketto’s Social Impact Plan members will help us realise this vision.”',
          raised: 15314256,
          supporters: '7,652',
          img: '/assets/images/education-fundraising/education-01.png'
        },
        {
          title: 'Indian Development foundation',
          description: '“Education opens doors and helps people break free from poverty. We’re grateful to the kind contributors who’ve chosen to sponsor the education of underprivileged children - they’re making a huge difference.”',
          raised: 1064826,
          supporters: '967',
          img: '/assets/images/education-fundraising/education-02.png'
        },
        {
          title: 'CRY India',
          description: '“Too many children in India cannot access basic education. It’s tragic but it’s not beyond hope. Thanks to the generosity of many contributors, we’ve been able to provide an education to many who need it.”',
          raised: 3555370,
          supporters: '2,019',
          img: '/assets/images/education-fundraising/education-03.png'
        }
      ]
    },
    testimonials: {
      cause: 'education',
      title: 'Testimonials',
      testimonials: [
        {
          content: `“The knowledge that I’m making a real, sustainable impact on a child’s life every single month brings me so much joy.”`,
          name: 'Gitanjali',
          image: '/assets/images/sip/testimonials/gitanjali.png',
          donor_type_text: 'Monthly Contributor'
        },
        {
          content: `“The best gift, in my opinion, is a book and a pencil. I feel very strongly that education changes everything and that’s why I contribute monthly.”`,
          name: 'Sarah',
          image: '/assets/images/sip/testimonials/sarah.png',
          donor_type_text: 'Monthly Contributor'
        },
        {
          content: `“I love finding out which child I’ve sponsored that month. I hope to educate as many children as I can.”`,
          name: 'Abdul',
          image: '/assets/images/sip/testimonials/abdul.png',
          donor_type_text: 'Monthly Contributor'
        }
      ]
    },
    dockbtn: {
      label: 'Start Monthly Giving'
    }
  },
  elderly: {
    cause: 'elderly',
    seo_data: {
      metaTitle: 'Care for the Elderly | Help Elderly with Ketto’s Social Impact Plan',
      metaDescription: 'With Ketto’s SIP you can help aged or elderly people for their medical care and day to day life expenses. Your small support can bring smiles on the faces many elderly people.',
      metaKeywords: 'help aged, care for the elderly, care for elderly, help aged',
      metaImage: `${environment.APP.DOMAIN_URL}/assets/images/elderly_og.png`
    },
    banner: {
      cause: 'elderly',
      image: '/assets/images/elderly-banner.png',
      title: 'Let’s Uplift & Support Senior citizens',
      text: 'Join a community of Change-makers giving our elders a better life.'
    },
    monthly_program: {
      cause: 'elderly',
      title: 'Support Senior Citizens',
      text: 'Provide warm, loving homes for elders across India.',
      points: [
        { icon: 'restaurant', text: 'Help provide food, shelter and essential treatments' },
        { icon: 'update', text: 'Regular updates on their current condition' },
        { icon: 'percent', text: 'Tax deduction under Section 80G' },
        { icon: 'cancel', text: 'Cancel Anytime' }
      ]
    },
    achievements: {
      cause: 'elderly',
      desktop_image: '/assets/images/elder_desktop.png',
      mobile_image: '/assets/images/elder_mobile.png',
      raised: '60cr+',
      donors: '250k+',
      saved: '4k+',
      saved_text: 'Elderly Helped'
    },
    success_stories: {
      cause: 'elderly',
      title: 'Success Stories',
      stories: [
        {
          title: 'Elder Support Foundation',
          description: 'With thousands of elders to care for, we’re constantly striving to ensure they are well taken care of. The support that we receive from Ketto’s Social Impact Plan members will help us realise this vision.',
          raised: 153142562,
          supporters: '7,652',
          img: '/assets/images/success-elder-1.png'
        },
        {
          title: 'Indian Development foundation',
          description: 'Home to more than 800 elders, we are always striving to provide for and take care of them. The response that we received from Ketto greatly helped us raise funds to help our  elderly friends.',
          raised: 10648263,
          supporters: '967',
          img: '/assets/images/success-elder-2.png'
        },
        {
          title: 'Helpage India',
          description: 'Initially, we were struggling to maintain quality services, food and medical attention for the elders under our care. But thanks to generous contributors and Ketto, we were saved from this financial crisis.',
          raised: 35553706,
          supporters: '2,019',
          img: '/assets/images/success-elder-3.png'
        }
      ]
    },
    testimonials: {
      cause: 'elderly',
      title: 'Testimonials',
      testimonials: [
        {
          content: `“It’s important to give back when we can- and senior citizens often get left out. This is why I contribute monthly.”`,
          name: 'Alisha',
          image: '/assets/images/sip/testimonials/alisha.png',
          donor_type_text: 'Bangalore'
        },
        {
          content: `“Supporting elderly citizens and seeing the difference it makes brings a smile to my face.”`,
          name: 'Kritika',
          image: '/assets/images/sip/testimonials/kritika.png',
          donor_type_text: 'Delhi'
        },
        {
          content: `“I can go to sleep knowing I’ve done a small bit to make someone’s life better- and that’s why I come back every month.”`,
          name: 'Ankush',
          image: '/assets/images/sip/testimonials/ankush.png',
          donor_type_text: 'Kolkata'
        }
      ]
    },
    dockbtn: {
      label: 'Support the Elderly'
    }
  },
  food_hunger: {
    cause: 'food_hunger',
    seo_data: {
      metaTitle: 'Feed Hungry | Feed the Needy with Ketto’s SIP Contribution',
      metaDescription: 'Contribute monthly to extend your support in providing food for the hungry people. Join hands with Ketto’s SIP to feed the needy in India.',
      metaKeywords: 'food for the hungry, feed hungry, feed the needy, food for needy',
      metaImage: `${environment.APP.DOMAIN_URL}/assets/images/foodhunger_og.png`
    },
    banner: {
      cause: 'food_hunger',
      image: '/assets/images/foodandhunger_banner.png',
      title: 'Let’s feed a hungry child nutritious meals',
      text: 'Join a community of monthly contributors committed to fighting hunger in India'
    },
    monthly_program: {
      cause: 'food_hunger',
      title: 'Help Solve  Hunger Today',
      text: 'Feed a hungry child warm, nutritious meals',
      points: [
        { icon: 'ramen_dining', text: 'Feed a child nutritious meal regularly' },
        { icon: 'update', text: 'Receive timely updates on your impact' },
        { icon: 'percentage', text: 'Get tax relief under Section 80G' },
        { icon: 'cancel', text: 'Cancel anytime' }
      ]
    },
    achievements: {
      cause: 'food_hunger',
      desktop_image: '/assets/images/Foodandhunger_desktop.png',
      mobile_image: '/assets/images/foodandhunger_mobile.png',
      raised: '60cr+',
      donors: '250k+',
      saved: '4k+',
      saved_text: 'Kids Fed'
    },
    success_stories: {
      cause: 'food_hunger',
      title: 'Success Stories',
      stories: [
        {
          title: 'Child Health Foundation',
          description: 'With thousands of children to care for, we’re constantly striving to ensure they grow up equipped to build a better future. The support that we receive from Ketto’s Social Impact Plan members will help us realise this vision.',
          raised: 153142562,
          supporters: '7,652',
          img: '/assets/images/success-foodandhunger-1.png'
        },
        {
          title: 'Indian Development foundation',
          description: 'In order for a child to have a chance at a bright future, they need to eat healthy meals every day. We’re grateful to the kind contributors who’ve chosen to sponsor meals of underprivileged children - they’re making a huge difference.',
          raised: 10648263,
          supporters: '967',
          img: '/assets/images/success-foodandhunger-2.png'
        },
        {
          title: 'CRY India',
          description: 'Too many children in India cannot access basic food. It’s tragic but it’s not beyond hope. Thanks to the generosity of many contributors, we’ve been able to provide proper meals to many who need it.',
          raised: 35553706,
          supporters: '2,019',
          img: '/assets/images/success-foodandhunger-3.png'
        }
      ]
    },
    testimonials: {
      cause: 'food_hunger',
      title: 'Testimonials',
      testimonials: [
        {
          content: `“A few minutes of time can keep a child from starving. Contributing monthly is a humbling experience and makes me so thankful for all that I can give to those in need.”`,
          name: 'Gitanjali',
          image: '/assets/images/sip/testimonials/gitanjali.png',
          donor_type_text: 'Dehradun'
        },
        {
          content: `“Food is a human right. To be able to help those who go to sleep hungry every night brings me so much joy.”`,
          name: 'Sarah',
          image: '/assets/images/sip/testimonials/sarah.png',
          donor_type_text: 'Chandigarh'
        },
        {
          content: `“Nobody deserves to starve. Contributing monthly and making a real impact , that too at a pocket-friendly price, fills me with gratitude.”`,
          name: 'Abdul',
          image: '/assets/images/sip/testimonials/abdul.png',
          donor_type_text: 'Agra'
        }
      ]
    },
    dockbtn: {
      label: 'Contribute Healthy Meals'
    }
  },
  acid_victims: {
    cause: 'acid_victims',
    seo_data: {
      metaTitle: 'People Supporting People: Your support, their survival | Ketto Medical Crowdfunding',
      metaDescription: 'By contributing generously to campaigns on Ketto you can save lives. Contribute today to Crowdfunding for medical expenses and medical treatment.',
      metaKeywords: 'Medical Crowdfunding, Raise Funds for Medical Treatment, Medical fundraising, best way to raise money for medical expenses, fundraiser for medical expenses, Financial Help for Medical Treatment in India, Fundraising for Medical Expenses',
      metaImage: `${environment.APP.DOMAIN_URL}/assets/images/acid_attack_01.png`
    },
    banner: {
      cause: 'acid_victims',
      image: '/assets/images/acid_attack_01.png',
      title: `Let's empower acid attack victims and make a difference.`,
      text: 'Become part of a community of change-makers, who empower lives every month.'
    },
    monthly_program: {
      cause: 'acid_victims',
      title: 'Empower a life, every month',
      text: 'Our holistic approach goes beyond medical and emotional support, aiming to equip survivors with skills that lead to meaningful work, independence, and long-term empowerment.',
      points: [
        { icon: 'handshake', text: `Priority contributions towards victim's needs.` },
        { icon: 'update', text: 'Regular updates on their current condition' },
        { icon: 'percent', text: 'Tax deduction under Section 80G' },
        { icon: 'cancel', text: 'Cancel Anytime' }
      ]
    },
    achievements: {
      cause: 'acid_victims',
      desktop_image: '/assets/images/acidattack-fundraising/acidattack-desktop-01.jpg',
      mobile_image: '/assets/images/acidattack-fundraising/acidattack-mobile-01.jpg',
      raised: '15cr+',
      donors: '45,897',
      saved: '6,897',
      saved_text: 'Lives Saved'
    },
    testimonials: {
      cause: 'acid_victims',
      title: 'Testimonials',
      testimonials: [
        {
          content: `“Supporting Ketto's SIP for acid attack survivors has been an incredibly rewarding experience. Knowing that my small, monthly contribution helps these brave women rebuild their lives fills me with pride. It’s a simple commitment, but it makes a world of difference”`,
          name: 'Alisha',
          image: '/assets/images/sip/testimonials/alisha.png',
          donor_type_text: 'Bangalore'
        },
        {
          content: `“Through Ketto's SIP, I feel like I'm part of something truly impactful. My monthly contribution may seem small, but it’s helping survivors heal and regain their confidence. It's amazing to see how consistent support can change lives.”`,
          name: 'Kritika',
          image: '/assets/images/sip/testimonials/kritika.png',
          donor_type_text: 'Delhi'
        },
        {
          content: `“Ketto's SIP allows me to help acid attack survivors in a meaningful way, even with just a small contribution each month. It feels good knowing that my support is giving them the care and hope they deserve. It's a commitment I'm proud to make.”`,
          name: 'Ankush',
          image: '/assets/images/sip/testimonials/ankush.png',
          donor_type_text: 'Kolkata'
        }
      ]
    },
    dockbtn: {
      label: 'Start Monthly Giving'
    }
  }
};
